import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, onBeforeUnmount, onMounted, ref, set, useSlots } from 'vue';
import ResizeObserver from 'resize-observer-polyfill';
var __default__ = {
    name: 'XPlaceholder'
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    setup: function setup(__props) {
        var heightList = ref([]);
        var height = computed(function() {
            return heightList.value.reduce(function(acc, cur) {
                return acc += cur;
            }, 0);
        });
        var widthList = ref([]);
        var width = computed(function() {
            return widthList.value.reduce(function(acc, cur) {
                return acc += cur;
            }, 0);
        });
        /**
 * 更新记录的子节点尺寸
 * @param el
 * @param index
 */ var updateSize = function updateSize(el, index) {
            var _el_getBoundingClientRect = el.getBoundingClientRect(), width = _el_getBoundingClientRect.width, height = _el_getBoundingClientRect.height;
            set(widthList.value, index, width);
            set(heightList.value, index, height);
        };
        var slots = useSlots();
        var elements = ref([]);
        var observers = ref([]);
        onMounted(function() {
            var _ref;
            var _slots_default;
            // 获取所有子节点
            elements.value = (_ref = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots).map(function(vnode) {
                return vnode.elm;
            }).filter(function(v) {
                return v;
            })) !== null && _ref !== void 0 ? _ref : [];
            // 初始化用于存储子节点宽度及高度的列表
            heightList.value = Array(elements.value.length).fill(0);
            widthList.value = Array(elements.value.length).fill(0);
            // 更新尺寸及创建对应的ResizeObserver
            elements.value.forEach(function(element, index) {
                updateSize(element, index);
                observers.value.push(new ResizeObserver(function(entries) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var entry = _step.value;
                            updateSize(entry.target, index);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }));
            });
            observers.value.forEach(function(observer, index) {
                observer.observe(elements.value[index]);
            });
        });
        onBeforeUnmount(function() {
            observers.value.forEach(function(observer, index) {
                observer.unobserve(elements.value[index]);
            });
        });
        return {
            __sfc: true,
            heightList: heightList,
            height: height,
            widthList: widthList,
            width: width,
            updateSize: updateSize,
            slots: slots,
            elements: elements,
            observers: observers
        };
    }
}));
